import { render } from "./adminReport.vue?vue&type=template&id=7d315996&scoped=true"
import script from "./adminReport.vue?vue&type=script&lang=js"
export * from "./adminReport.vue?vue&type=script&lang=js"

import "./adminReport.vue?vue&type=style&index=0&id=7d315996&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d315996"]])

export default __exports__